module.exports = __webpack_public_path__ + "img/VL_12_03.79d4b9d9.png";